<div class="row masonry clearfix">
    <a href="javascript:void(0)" *ngFor="let pic of childimage" class="col-lg-4 col-sm-6 grid-item photography video-icon">
        <figure class="portfolio-item">
            <img [src]="pic.src" alt="" width="350px" height="250px" />
            <figcaption>
                <h3 class="title">{{pic.title}}</h3>
                <span>{{pic.content}}</span>
            </figcaption>
        </figure>
    </a>
</div>